/* eslint-disable quotes */
const headerSticky = () => {
  const headerEl = document.getElementById("top-menu");
  if (headerEl) {
    headerEl.classList.toggle("sticky-active", window.scrollY > 100);
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        // document.body.classList.add("sticky-active");
        headerEl.classList.add("sticky-active");
      }
      if (window.scrollY < 1) {
        // document.body.classList.remove("sticky-active");
        headerEl.classList.remove("sticky-active");
      }
    });
  }
};

export default headerSticky;



// WEBPACK FOOTER //
// ./scripts/plugins/headerSticky.js